import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AdminLayout from "./Components/AdminLayout";
import ProtectedRoute from "./Components/ProtectedRoute";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Login from "./Pages/Login/Login.jsx";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword.jsx";
import ResetPassword from "./Pages/ResetPassword/ResetPassword.jsx";
import CreateAdmin from "./Pages/CreateAdmin/CreateAdmin.jsx";
import UpdateItem from "./Pages/UpdateItem/UpdateItem.jsx";
import CreateItem from "./Pages/CreateItem/CreateItem.jsx";
import Order from "./Pages/Order/Order.jsx";
import CreatePlatter from "./Pages/CreatePlatter/CreatePlatter.jsx";
import UpdatePlatter from "./Pages/UpdatePlatter/UpdatePlatter.jsx";
import Mango from "./Pages/Mango/Mango.jsx";
import Staff from "./Pages/Staff/Staff.jsx";
import Customers from "./Pages/Customers/Customers.jsx";
import Settings from "./Pages/Settings/Settings.jsx";
import Restaurants from "./Pages/Restaurants/Restaurants.jsx";
import Categories from "./Pages/Categories/Categories.jsx";
import Sliders from "./Pages/Sliders/Sliders.jsx";

function App() {
  const role = localStorage.getItem("role")
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected routes (including Sidebar) */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    {(role === "super_admin" || role === "admin") && <Route path="create-admin" element={<CreateAdmin />} />}
                    {(role === "super_admin" || role === "admin") && <Route path="staff" element={<Staff />} />}
                    {(role === "super_admin" || role === "admin") && <Route path="settings" element={<Settings />} />}
                    <Route path="/create-item" element={<CreateItem />} />
                    <Route path="/update-item" element={<UpdateItem />} />
                    <Route path="/create-platter" element={<CreatePlatter />} />
                    <Route path="/update-platter" element={<UpdatePlatter />} />
                    <Route path="/mango" element={<Mango />} />
                    <Route path="/restaurants" element={<Restaurants />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/sliders" element={<Sliders />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/orders" element={<Order />} />
                    {/* Redirect any unmatched routes */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </AdminLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
